import { slicedToArray as _slicedToArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { useDotButton, DotButton } from './EmblaCarouselDotButton.js';
import { usePrevNextButtons, PrevButton, NextButton } from './usePrevNextButtons.js';
import { Container } from './Carousel.styles.js';

var Carousel = function Carousel(_ref) {
  var children = _ref.children,
    isMobile = _ref.isMobile,
    carouselLayout = _ref.carouselLayout,
    boxShadow = _ref.boxShadow;
  var hasBoxShadow = boxShadow;
  if (!hasBoxShadow) {
    hasBoxShadow = children.some(function (c) {
      var _c$props;
      return !!(c !== null && c !== void 0 && (_c$props = c.props) !== null && _c$props !== void 0 && _c$props.packageData);
    });
  }
  var _useEmblaCarousel = useEmblaCarousel({
      containScroll: 'trimSnaps',
      loop: false,
      align: 'start'
    }),
    _useEmblaCarousel2 = _slicedToArray(_useEmblaCarousel, 2),
    emblaRef = _useEmblaCarousel2[0],
    emblaApi = _useEmblaCarousel2[1];
  var _useDotButton = useDotButton(emblaApi),
    selectedIndex = _useDotButton.selectedIndex,
    scrollSnaps = _useDotButton.scrollSnaps,
    onDotButtonClick = _useDotButton.onDotButtonClick;
  var _usePrevNextButtons = usePrevNextButtons(emblaApi),
    prevBtnDisabled = _usePrevNextButtons.prevBtnDisabled,
    nextBtnDisabled = _usePrevNextButtons.nextBtnDisabled,
    onPrevButtonClick = _usePrevNextButtons.onPrevButtonClick,
    onNextButtonClick = _usePrevNextButtons.onNextButtonClick;
  return /*#__PURE__*/React__default.createElement(Container, {
    className: "embla",
    isMobile: isMobile,
    carouselLayout: carouselLayout,
    boxShadow: hasBoxShadow
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "embla__viewport",
    ref: emblaRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "embla__container"
  }, React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "embla__slide",
      key: child === null || child === void 0 ? void 0 : child.key
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "embla__slide__number"
    }, child));
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "embla__controls"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "embla__buttons"
  }, /*#__PURE__*/React__default.createElement(PrevButton, {
    onClick: onPrevButtonClick,
    disabled: prevBtnDisabled
  }), /*#__PURE__*/React__default.createElement(NextButton, {
    onClick: onNextButtonClick,
    disabled: nextBtnDisabled
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "embla__dots"
  }, scrollSnaps.map(function (_, index) {
    return /*#__PURE__*/React__default.createElement(DotButton, {
      key: _,
      onClick: function onClick() {
        return onDotButtonClick(index);
      },
      className: 'embla__dot'.concat(index === selectedIndex ? ' embla__dot--selected' : '')
    });
  }))));
};
var Carousel$1 = Carousel;

export { Carousel$1 as default };
//# sourceMappingURL=index.js.map
